import styled from "styled-components";

export const Container = styled.section`
  .p_title {
    width: 100%;
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    & div {
      margin-bottom: 0px !important;
    }
    @media screen and (max-width: 1199px) {
      display: none;
    }
    .breadcrumb {
      grid-column: 3 span / 3 span;
    }
  }
  .m_title {
    display: none;
    @media screen and (max-width: 1199px) {
      display: flex;
    }
  }
`;

export const ListViewTypeWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const ListViewSelectBox = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  & span {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 10px;
    border: 1px solid #ececec;
    cursor: pointer;
  }

  .selected {
    background-color: #3bb77e;
    color: white;
    border: 1px solid #3bb77e;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  border: 1px solid #3bb77e;
  background-color: #f1f1f1;
  padding: 10px;

  .cnt {
    font-size: 16px;
  }
  .filter {
    width: fit-content;
  }

  @media (max-width: 991px) {
    display: flex;
    flex-direction: column;
    .cnt {
      width: 100%;
      margin-bottom: 10px;
    }
    .filter {
      width: 100%;
    }
  }
  @media (max-width: 767px) {
    & span {
      font-size: 14px;
    }
  }
`;

export const ProductsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${(props) =>
    props.searchTerm ? "repeat(4, 1fr)" : "repeat(4, 1fr)"};
  grid-column-gap: 10px;
  grid-row-gap: 20px;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ProductsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ProductsSignWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  word-break: keep-all;
  margin-top: 50px;
  & h4 {
    margin-bottom: 20px;
    text-align: center;
  }
`;

export const StickyMenu = styled.div`
  @media screen and (max-width: 1199px) {
    /* display: flex;
    .sidebar-widget {
      width: 30%;
      margin-right: 20px;
    }
    .banner-img {
      width: 70%;
      height: fit-content;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 20px;
    } */
  }
`;

export const MenuBanner = styled.div`
  & img {
    margin-bottom: 10px;
  }

  @media screen and (max-width: 1199px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10px;
    overflow: hidden;
  }
  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const MenuList = styled.ul`
  @media screen and (max-width: 1199px) {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 10px;
  }
  @media (max-width: 991px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 545px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

// table type list
export const TableTypeWrapper = styled.div`
  display: flex;
  overflow-x: auto;
`;

export const Table = styled.table`
  color: #253d4e;
  .header {
    background-color: #f9f6f6ba;
  }
  & tr {
    text-align: center;
    :hover {
      background-color: #f9f6f6ba;
    }
  }

  & th {
    padding: 5px;
    font-size: 14px;
    word-break: keep-all;
  }

  & td {
    padding: 10px;
    vertical-align: middle;
    text-align: center;
    white-space: nowrap;
  }

  & a {
    color: #253d4e;
  }

  .img {
    width: 10%;
    padding: 5px;
    & a {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .name {
    & a {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: pre-wrap;
      text-overflow: ellipsis;
      word-break: keep-all;
      :hover {
        color: #3bb77e;
      }
    }
  }

  .price {
    color: #dc3545;
  }

  .sizes {
    > div {
      width: fit-content;
      margin: 0 auto;
      text-align: start;
    }
  }

  @media (max-width: 991px) {
    & td {
      padding: 5px;
    }
    .golgi {
      width: 7%;
    }
    .strength {
      display: none;
    }
    .feature {
      width: 15%;
    }
    .sizes {
      width: 10%;
    }
    .onePrice {
      width: 10%;
    }
    .quantity {
      width: 10%;
    }
    .price {
      width: 13%;
    }
  }
  @media (max-width: 767px) {
    & th {
      font-size: 12px;
    }
    & td {
      font-size: 12px;
    }
    .img {
      display: none;
    }
    .sizes {
      width: 13%;
    }
    .golgi {
      width: 10%;
    }
    .price {
      width: 13%;
    }
  }
  @media (max-width: 575px) {
    & th {
      font-size: 10px;
    }
    & td {
      font-size: 10px;
      padding: 5px;
    }
    .sizes {
      display: none;
    }
  }
  @media (max-width: 460px) {
    .quantity {
      display: none;
    }
    .onePrice {
      display: none;
    }
  }
`;

export const BtnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  word-break: keep-all;
  @media (max-width: 991px) {
    font-size: 14px;
    line-height: 1.5;
  }
  @media (max-width: 767px) {
    font-size: 10px;
  }
  @media (max-width: 575px) {
    font-size: 8px;
  }
`;

export const CheckoutBtn = styled.button`
  background-color: #fd7e14;
  color: #fff;
  border: 1px solid #fd7e14;
  margin-bottom: 2px;
  padding: 4px 12px !important;

  :hover {
    opacity: 0.8;
  }
`;

export const CartBtn = styled.button`
  background-color: ${(props) => (props.inCart ? "#3bb77e" : "#fff")};
  color: ${(props) => (props.inCart ? "#fff" : "#3bb77e")};
  border: 1px solid #3bb77e;
  padding: 4px 12px !important;

  :hover {
    opacity: 0.8;
  }
`;

export const PriceBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;

  & > div {
    & span {
      text-decoration: line-through;
      color: #6c757d;
      opacity: 0.5;
    }
  }
`;

// 카테고리 부분
export const CategoryWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 10px;
`;

// 카테고리 개별 구분
export const CategorySliderName = styled.a`
  padding: 0px 5px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
`;
